import { render } from "./AppNavbar.vue?vue&type=template&id=b0d44e78"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ws\\me\\fast-file\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__